export const QUERY_AUTH = {
    CLEAR_AUTH: 'clear_auth',
    PROMO_ACTIVATION: 'promoActivation',
} as const;
